module.exports = __webpack_public_path__ + "static/media/hus.ad2d0c78.m4a";